

namespace PaperTrail.NewsletterControl{

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.maximizable()
    export class NewsletterPageTemplateEditorDialog extends Serenity.Extensions.GridEditorDialog<PageTemplateRow> {
        protected getFormKey() { return NewsletterPageTemplateForm.formKey; }
        protected getNameProperty() { return NewsletterPageTemplateRow.nameProperty; }
        protected getLocalTextPrefix() { return NewsletterPageTemplateRow.localTextPrefix; }

        protected form: NewsletterPageTemplateForm;
        private loadedState: string;
        //public  _claimantID: number;

        constructor() { 
            super();
            this.form = new NewsletterPageTemplateForm(this.idPrefix);
            Serenity.Extensions.DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);
             
        } 

        // This is called when save/update button is pressed
        protected save(callback: (response: Serenity.SaveResponse) => void) {

            debugger;
            Serenity.SubDialogHelper.triggerDataChange(this);
            super.save(callback); 
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        loadResponse(data) {
            super.loadResponse(data);
            this.loadedState = this.getSaveState();
        }

    }
}